import { Container, Row, Col, Image } from "react-bootstrap";
import { 
    MemberTabSection,
    MemberBannerSection,
} from './membersStyle'
import TabSection from '../../../components/common/Tab';
import { 
    Title,
    WriteReviewSection,
    ReviewText,
    ReviewRightSection,
    RightBanner,
} from "../../../components/common/commonSubBanner/commonSubBannerStyle";
import ReviewImage from "../../../assests/images/memberbanner.webp";
import { useLocation } from "react-router-dom";
import MetaComponent from "../../../components/common/metaComponent";

const Members = () => {
    const {pathname} = useLocation();
    return (
    <>
    <MetaComponent 
            keywords=""
            description=""
            ogTitle={(pathname === "/about/board-members" && "Board Members | GreatNonprofits") || (pathname === "/about/team" &&  "Team Members | GreatNonprofits") || (pathname === "/about/advisory-board" &&  "Advisory Board Members | GreatNonprofits")}
            ogDescription=""
            ogUrl={(pathname === "/about/board-members" && "https://www.about.greatnonprofits.org/board-members") || (pathname === "/about/team" &&  "https://www.about.greatnonprofits.org/team") || (pathname === "/about/advisory-board" &&  "https://www.about.greatnonprofits.org/advisory-board")}
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
        <MemberBannerSection>
            {/* <CommonSubBanner/>  */}
            <WriteReviewSection className="border-member-banner">
                <Container className="cont-w"> 
                    <Row>
                        {/* Board Members */}
                        {pathname === "/about/board-members" && 
                        <Col lg={6} sm={12} md={12}>
                            <Title>The GreatNonprofits Board Members</Title>
                            <ReviewText>At Great Nonprofit, we are proud of our Board Members of professionals who work hard every day to ensure our users have a smooth and satisfactory experience. Our team is composed of experts in customer service, technology, marketing, and operations who are always ready to assist you.</ReviewText>
                        </Col>
                        }
                        {/* Team Members */}
                        {pathname === "/about/team" && 
                        <Col lg={6} sm={12} md={12}>
                            <Title>The GreatNonprofits Team Members</Title>
                            <ReviewText>At Great Nonprofit, we are proud of our Team Members of professionals who work hard every day to ensure our users have a smooth and satisfactory experience. Our team is composed of experts in customer service, technology, marketing, and operations who are always ready to assist you.</ReviewText>
                        </Col>}
                        {/* Advisory Board */}
                        {pathname === "/about/advisory-board" && 
                        <Col lg={6} sm={12} md={12}>
                            <Title>The GreatNonprofits Advisory Board</Title>
                            <ReviewText>At Great Nonprofit, we are proud of our Advisory Board Members of professionals who work hard every day to ensure our users have a smooth and satisfactory experience. Our team is composed of experts in customer service, technology, marketing, and operations who are always ready to assist you.</ReviewText>
                        </Col>}
                        
                        <Col lg={6} sm={12} md={12}>
                            <RightBanner className="left_banner">
                                <ReviewRightSection className="member-board">
                                    <Image src={ReviewImage} alt="ReviewImage"/>
                                </ReviewRightSection>
                            </RightBanner>
                        </Col>
                    </Row>
                </Container>
            </WriteReviewSection>
        </MemberBannerSection> 

        <MemberTabSection>
          <TabSection/>
      </MemberTabSection>
    </>
    )
};
export default Members; 